import { onMounted, onUnmounted } from "vue"
import { useRouter } from "vue-router"
import { onAngularEvent, startAngularBridge } from "@/utils/angularEmbed"
import { logout } from "@/composables/useSession"
import { workerStore } from "@/store/worker"

const isPositiveInt = (value: unknown): value is number =>
	typeof value === "number" && Number.isInteger(value) && value > 0

/**
 * Приём сообщений от Angular-гостя, живущего в iframe.
 *
 * Поднимается один раз из App.vue: эффекты глобальные (локаль, сессия и
 * переходы всего приложения).
 */
export function useAngularBridge(): void {
	const router = useRouter()
	let stop: (() => void) | null = null

	onMounted(() => {
		const unsubscribeLanguage = onAngularEvent("language_changed", (event) => {
			workerStore()
				.setLanguageFromAngular(event.language)
				.catch((e) => console.error(e))
		})
		// Гость потерял авторизацию и показывает свой логин. Сами мы узнали бы
		// об этом только на собственном 401, поэтому гасим сессию по объявлению.
		const unsubscribeSession = onAngularEvent("session_expired", () => {
			logout()
		})
		// Клик по ссылке на Клиента/Проекта в календаре; jobId подсветит работу в списке.
		const unsubscribeEntity = onAngularEvent("open_entity", (event) => {
			if ((event.entity !== "client" && event.entity !== "project") || !isPositiveInt(event.id)) {
				return
			}
			const query: Record<string, string> = { page: event.entity, id: String(event.id) }
			if (isPositiveInt(event.jobId)) {
				query.jobId = String(event.jobId)
			}
			router.push({ path: "/main", query }).catch((e) => console.error(e))
		})
		const stopListening = startAngularBridge()
		stop = () => {
			unsubscribeLanguage()
			unsubscribeSession()
			unsubscribeEntity()
			stopListening()
		}
	})

	onUnmounted(() => {
		stop?.()
		stop = null
	})
}
